var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.18652 9.38574V9.06055C7.18652 8.7793 7.24658 8.53467 7.3667 8.32666C7.48682 8.11865 7.70654 7.89746 8.02588 7.66309C8.3335 7.44336 8.53564 7.26465 8.63232 7.12695C8.73193 6.98926 8.78174 6.83545 8.78174 6.66553C8.78174 6.4751 8.71143 6.33008 8.5708 6.23047C8.43018 6.13086 8.23389 6.08105 7.98193 6.08105C7.54248 6.08105 7.0415 6.22461 6.479 6.51172L6 5.54932C6.65332 5.18311 7.34619 5 8.07861 5C8.68213 5 9.16113 5.14502 9.51562 5.43506C9.87305 5.7251 10.0518 6.11182 10.0518 6.59521C10.0518 6.91748 9.97852 7.1958 9.83203 7.43018C9.68555 7.66455 9.40723 7.92822 8.99707 8.22119C8.71582 8.4292 8.53711 8.5874 8.46094 8.6958C8.3877 8.8042 8.35107 8.94629 8.35107 9.12207V9.38574H7.18652ZM7.0459 10.8887C7.0459 10.6426 7.11182 10.4565 7.24365 10.3306C7.37549 10.2046 7.56738 10.1416 7.81934 10.1416C8.0625 10.1416 8.25 10.2061 8.38184 10.335C8.5166 10.4639 8.58398 10.6484 8.58398 10.8887C8.58398 11.1201 8.5166 11.3032 8.38184 11.438C8.24707 11.5698 8.05957 11.6357 7.81934 11.6357C7.57324 11.6357 7.38281 11.5713 7.24805 11.4424C7.11328 11.3105 7.0459 11.126 7.0459 10.8887Z",
    fill: "#555770"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/questionMark.0e103c62f487ebded468a98ce96c05d6.svg";
export { ForwardRef as ReactComponent };